export interface IUrlParams {
  viewMode: string | null
}
declare global {
  interface Window {
    urlParams: IUrlParams | null
    page_source: string | null
  }
}
export const setParamsFromUrl = () => {
  // 获取链接参数
  const queryString = window.location.href.split('#/?')[1] || ''
  // 将参数转换为对象
  const params = new URLSearchParams(queryString)
  // 其他使用的参数
  const viewMode = params.get('viewMode')
  // console.log('==========viewMode==========================')
  // console.log(viewMode)
  // console.log('====================================')
  window.urlParams = {
    viewMode,
  }

  const page_source = params.get('page_source')
  // console.log('====================================')
  // console.log('page_source', page_source)
  // console.log('====================================')
  window.page_source = page_source || 'chargermap'
}
